// Signed control messages. A delete-for-everyone tombstone is authenticated with the
// sender's long-term identity-signing key so honest clients (and the server) can prove it
// really came from the original author before honoring it.
import { signableBytes, toB64, fromB64 } from "@shared/encoding.js";
import { PROTOCOL_VERSION } from "@shared/constants.js";
import type { Tombstone, PurgeDirective } from "@shared/wire.js";
import { sign, verify } from "./sodium.js";

export interface TombstoneFields {
  conv_id: string;
  msg_id: string;
  sender_id: string;
  ts: number;
}

export function signTombstone(ikSigPriv: Uint8Array, fields: TombstoneFields): Tombstone {
  const payload = { v: PROTOCOL_VERSION, ...fields };
  return { ...payload, sig: toB64(sign(signableBytes(payload), ikSigPriv)) };
}

export function verifyTombstone(tomb: Tombstone, senderSigPub: Uint8Array): boolean {
  const { sig, ...payload } = tomb;
  return verify(fromB64(sig), signableBytes(payload), senderSigPub);
}

export interface PurgeFields {
  conv_id: string;
  sender_id: string;
  after_ts: number;
  ts: number;
}

export function signPurge(ikSigPriv: Uint8Array, fields: PurgeFields): PurgeDirective {
  const payload = { v: PROTOCOL_VERSION, ...fields };
  return { ...payload, sig: toB64(sign(signableBytes(payload), ikSigPriv)) };
}
